import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'

const routes = [
  // ==================== 메인 ====================
  // 홈 대시보드
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },

  // ==================== 대출신청/실행 ====================
  // 대출실행 검색
  {
    path: '/loan/lontmlf',
    name: 'LontMlfSearch',
    component: () => import('@/components/loan/LontMlfSearch.vue')
  },
  // 대출실행 생성
  {
    path: '/loan/create',
    name: 'LoanExecutionCreate',
    component: () => import('@/components/loan/LoanExecutionCreate.vue')
  },
  // P14 (2026-06-20) — 대출신청/실행(테스트) — 신규/추가대출 단위 검증 콘솔 (운영 진입 시 삭제 예정)
  {
    path: '/loan/test-console',
    name: 'LoanTestConsole',
    component: () => import('@/components/loan/LoanTestConsole.vue')
  },
  // 대출현황
  {
    path: '/loan/LoanList',
    name: 'LoanList',
    component: () => import('@/components/loan/LoanList.vue')
  },
  // 대출신청내역조회
  {
    path: '/loan/app-list',
    name: 'LoanAppList',
    component: () => import('@/components/loan/LoanAppList.vue')
  },
  // 대출신청 상세조회
  {
    path: '/loan/app-detail',
    name: 'LoanAppDetail',
    component: () => import('@/components/loan/LoanAppDetail.vue')
  },
  // 계좌상세조회
  {
    path: '/loan/detail',
    name: 'LoanDetail',
    component: () => import('@/components/loan/LoanDetail.vue')
  },
  // 만기연장처리 (→ 연장관리 통합 화면으로 이동)
  {
    path: '/loan/extension',
    redirect: '/extension/management'
  },
  // 거래이력 조회
  {
    path: '/loan/transaction-history',
    name: 'TransactionHistory',
    component: () => import('@/components/loan/TransactionHistory.vue')
  },
// ==================== 상환관리 ====================
  // 상환신청내역조회
  {
    path: '/repay/repayment-list',
    name: 'RepaymentList',
    component: () => import('@/components/repay/RepaymentList.vue')
  },
  // 이자출금처리
  {
    path: '/repay/interest-withdrawal',
    name: 'InterestWithdrawal',
    component: () => import('@/components/repay/InterestWithdrawal.vue')
  },

  // ==================== 상품관리 ====================
  // 상품현황
  {
    path: '/product/view',
    name: 'ProductViewer',
    component: () => import('@/components/product/ProductViewer.vue')
  },

  // ==================== 이자스케줄 ====================
  // 이자/수납 통합관리
  {
    path: '/interest/management',
    name: 'InterestManagement',
    component: () => import('@/components/interest/InterestManagement.vue')
  },
  // 이자스케줄 현황 (LONTMLF 기반)
  {
    path: '/schedule/list',
    name: 'InterestScheduleViewer',
    component: () => import('@/components/schedule/InterestScheduleViewer.vue')
  },
  // 이자스케줄 상세
  {
    path: '/schedule/detail',
    name: 'InterestScheduleDetail',
    component: () => import('@/components/schedule/InterestScheduleDetail.vue')
  },

  // ==================== 문자발송관리 ====================
  // SMS 이벤트/변수 관리
  {
    path: '/sms/event-type',
    name: 'SmsEventTypeManage',
    component: () => import('@/views/sms/SmsEventTypeManage.vue')
  },
  // 문자 템플릿 관리
  {
    path: '/sms/tmpl',
    name: 'SmsTmplManage',
    component: () => import('@/views/sms/SmsTmplManage.vue')
  },
  // 문자 수기 발송
  {
    path: '/sms/send',
    name: 'SmsDirectSend',
    component: () => import('@/views/sms/SmsDirectSend.vue')
  },
  // 문자 발송이력 조회
  {
    path: '/sms/log',
    name: 'SmsLogInquiry',
    component: () => import('@/views/sms/SmsLogInquiry.vue')
  },

  // ==================== 고객관리 ====================
  // 회원 조회 (가입 고객 전체)
  {
    path: '/customer/members',
    name: 'MemberList',
    component: () => import('@/components/customer/MemberList.vue')
  },
  // 대출고객 조회
  {
    path: '/customer/search',
    name: 'CustomerSearch',
    component: () => import('@/components/customer/CustomerSearch.vue')
  },

  // ==================== 시스템관리 ====================
  // 휴일관리
  {
    path: '/system/holiday',
    name: 'HolidayManager',
    component: () => import('@/components/system/HolidayManager.vue')
  },
  // P11 (2026-06-19) — 감사로그 조회 (거래이력 누락 / 잔고부족 알람)
  {
    path: '/system/audit-log',
    name: 'AuditLogView',
    component: () => import('@/components/system/AuditLogView.vue')
  },
  // 배치스케줄 관리
  {
    path: '/system/batch-schedule',
    name: 'BatchScheduleManagement',
    component: () => import('@/views/system/BatchScheduleManagement.vue')
  },
  // 암복호화 관리
  {
    path: '/system/crypto-tool',
    name: 'CryptoTool',
    component: () => import('@/components/system/CryptoTool.vue')
  },
  // 데몬배치 관리 (빌리언대부 보고)
  {
    path: '/system/daemon-batch',
    name: 'DaemonBatchManagement',
    component: () => import('@/views/system/DaemonBatchManagement.vue')
  },
  // 거래가능시간 관리
  {
    path: '/system/trade-time',
    name: 'TradeTimeManage',
    component: () => import('@/views/system/LontTimManage.vue')
  },
  // KCB 송수신 내역 조회
  {
    path: '/system/kcb-api-log',
    name: 'KcbApiLogInquiry',
    component: () => import('@/views/system/KcbApiLogInquiry.vue')
  },
  // AI 장애분석
  {
    path: '/system/ai-log-analyzer',
    name: 'AiLogAnalyzer',
    component: () => import('@/components/system/AiLogAnalyzer.vue')
  },
  // AI 상담 도우미 (대부사 고객상담지원)
  {
    path: '/system/consult-assistant',
    name: 'ConsultAssistant',
    component: () => import('@/components/system/ConsultAssistant.vue')
  },

  // ==================== 계정관리 ====================
  // 회원사 관리
  {
    path: '/admin/coinfo',
    name: 'CoInfoManage',
    component: () => import('@/components/login/CoInfoManager.vue')
  },
  // 관리자 관리
  {
    path: '/admin/user',
    name: 'AdminUserManage',
    component: () => import('@/components/login/AdminUserCreate.vue')
  },
  // 권한 관리
  {
    path: '/admin/authorization',
    name: 'AdminAuthorization',
    component: () => import('@/components/login/AdminAuthorization.vue')
  },
  // 로그인 이력
  {
    path: '/admin/login-log',
    name: 'AdminLoginLog',
    component: () => import('@/components/login/AdminLoginLog.vue')
  },
  // 로그인
  {
    path: '/auth/login',
    name: 'Login',
    component: () => import('@/components/login/Login.vue')
  },

  // ==================== RMS연계 ====================
  // 기한이익상실 관리
  {
    path: '/rmslink/rms-forced',
    name: 'RmsForced',
    component: () => import('@/components/rmslink/RmsForced.vue')
  },
  // RMS 계좌상세
  {
    path: '/rmslink/account-detail',
    name: 'RmsAccountDetail',
    component: () => import('@/components/rmslink/RmsAccountDetail.vue')
  },
  // 종목관리
  {
    path: '/rmslink/item-management',
    name: 'ItemManagement',
    component: () => import('@/components/rmslink/ItemManagement.vue')
  },
  // 종목등급 버전비교 (채점 엔진 버전 간 등급·컷오프 변화 진단)
  {
    path: '/rmslink/grade-compare',
    name: 'GradeVersionCompare',
    component: () => import('@/components/rmslink/GradeVersionCompare.vue')
  },
  // 계좌등급 버전비교 (산정표 버전 간 계좌등급·대출가능 변화)
  {
    path: '/rmslink/account-grade-compare',
    name: 'AccountGradeVersionCompare',
    component: () => import('@/components/rmslink/AccountGradeVersionCompare.vue')
  },
  // 라이프사이클 시뮬레이터 (계좌운영규칙 v1.08 — 신규대출→추가대출→상환→연장 검증, read-only)
  {
    path: '/rmslink/lifecycle-sim',
    name: 'LifecycleSimulator',
    component: () => import('@/components/rmslink/LifecycleSimulator.vue')
  },
  // 금지종목설정 (매수/보유금지종목 등록·수정·삭제)
  {
    path: '/rmslink/ban-stock',
    name: 'BanStockManagement',
    component: () => import('@/components/rmslink/BanStockManagement.vue')
  },
  // ETF 담보 화이트리스트 관리 (2026-07-02) — 강제 A등급 지정 대상 CRUD
  {
    path: '/rmslink/etf-whitelist',
    name: 'EtfWhitelistManagement',
    component: () => import('@/components/rmslink/EtfWhitelistManagement.vue')
  },
  // 등급정책 현황 (2026-07-16) — 가중·경계·집중률·다이얼 DB SSOT 조회 전용
  {
    path: '/rmslink/grade-policy',
    name: 'GradePolicyStatus',
    component: () => import('@/components/rmslink/GradePolicyStatus.vue')
  },

  // ==================== 상담지원(CRM) ====================
  // 상담 응대 가이드 (2026-07-17 프로토타입) — 표준 응대 카드 탐색·검색 (조회 전용)
  {
    path: '/crm/consult-guide',
    name: 'CrmConsultGuide',
    component: () => import('@/components/crm/CrmConsultGuide.vue')
  },
  // 상담 스크립트 관리 (2026-07-17) — 콘텐츠 등록·수정·삭제·검수·이미지 업로드 (시스템관리 메뉴)
  {
    path: '/system/crm-content',
    name: 'CrmContentManage',
    component: () => import('@/components/system/CrmContentManage.vue')
  },
  // 상담 이력 (2026-07-18 Phase 2) — 세션 목록 + 행위 타임라인 (조회 전용, 시스템관리 메뉴)
  {
    path: '/system/crm-consult-history',
    name: 'CrmConsultHistory',
    component: () => import('@/components/system/CrmConsultHistory.vue')
  },
  // 상담 분석 (2026-07-18 Phase 3) — 상담사별 지표·카드 TOP·시간대 분포 (조회 전용, 시스템관리 메뉴)
  {
    path: '/system/crm-consult-dashboard',
    name: 'CrmConsultDashboard',
    component: () => import('@/components/system/CrmConsultDashboard.vue')
  },

  // ==================== TCP/IP 설정/로그 ====================
  // TCP/IP 통신설정
  {
    path: '/tcp/config',
    name: 'TCPConfigManager',
    component: () => import('@/components/tcp_ip/TCPConfigManager.vue')
  },
  // TCP/IP 로그조회
  {
    path: '/tcp/log',
    name: 'TCPMsgLogViewer',
    component: () => import('@/components/tcp_ip/TCPMsgLogViewer.vue')
  },
  // Raw JSON 안내
  {
    path: '/tcp/raw-json-guide',
    name: 'RawJsonGuide',
    component: () => import('@/components/tcp_ip/RawJsonGuide.vue')
  },

  // ==================== 투자자 펀딩 관리 ====================

  // ─── 1. 투자 관리 (대주단) ───
  {
    path: '/investor/investor-list',
    name: 'InvestorList',
    component: () => import('@/components/investor/InvestorList.vue')
  },
  {
    path: '/investor/investor-detail',
    name: 'InvestorDetail',
    component: () => import('@/components/investor/InvestorDetail.vue')
  },
  {
    path: '/investor/investment-list',
    name: 'InvestmentList',
    component: () => import('@/components/investor/InvestmentList.vue')
  },
  // Capital Call 관리 (대주단 → 신탁모계좌 회차별 자본요청)
  {
    path: '/investor/capital-call',
    name: 'CapitalCallList',
    component: () => import('@/components/investor/CapitalCallList.vue')
  },
  // 대부회원사 자기자금 관리 (V33, Phase P1)
  {
    path: '/investor/mlf-fund',
    name: 'MlfOwnFundList',
    component: () => import('@/components/investor/MlfOwnFundList.vue')
  },
  // 미매칭 대출 정정 (P1 마무리)
  {
    path: '/investor/unmatched-loan',
    name: 'UnmatchedLoanFix',
    component: () => import('@/components/investor/UnmatchedLoanFix.vue')
  },
  // V50 (Phase P8 F1) — 업무 일자 관리 (업무개시/마감)
  {
    path: '/investor/biz-op',
    name: 'BizOperationManager',
    component: () => import('@/components/investor/BizOperationManager.vue')
  },

  // ─── 2. SPC 관리 ───
  {
    path: '/investor/spc-list',
    name: 'SpcList',
    component: () => import('@/components/investor/SpcList.vue')
  },
  {
    path: '/investor/spc-detail',
    name: 'SpcDetail',
    component: () => import('@/components/investor/SpcDetail.vue')
  },
  {
    path: '/investor/spc-create',
    name: 'SpcCreate',
    component: () => import('@/components/investor/SpcCreate.vue')
  },

  // ─── 3. 자산 운용 (대부사) ───
  {
    path: '/investor/loan-matching',
    name: 'LoanMatchingList',
    component: () => import('@/components/investor/LoanMatchingList.vue')
  },
  {
    path: '/investor/spc-collat-list',
    name: 'SpcCollatList',
    component: () => import('@/components/investor/SpcCollatList.vue')
  },

  // ─── 4. 수익/정산 ───
  {
    path: '/investor/distribution',
    name: 'DistributionList',
    component: () => import('@/components/investor/DistributionList.vue')
  },
  // V87 - SPC 청산 관리
  {
    path: '/investor/liquidation',
    name: 'SpcLiquidationManager',
    component: () => import('@/components/investor/SpcLiquidationManager.vue')
  },
  // SR 월/분기 정산
  {
    path: '/investor/settlement',
    name: 'SettlementList',
    component: () => import('@/components/investor/SettlementList.vue')
  },
  {
    path: '/investor/settlement-detail',
    name: 'SettlementDetail',
    component: () => import('@/components/investor/SettlementDetail.vue')
  },
  {
    path: '/investor/sr-accrual',
    name: 'SrAccrualHistory',
    component: () => import('@/components/investor/SrAccrualHistory.vue')
  },

  // ─── 5. 모니터링 ───
  {
    path: '/investor/dashboard',
    name: 'FundingDashboard',
    component: () => import('@/components/investor/FundingDashboard.vue')
  },
  {
    path: '/investor/spc-asset-chain',
    name: 'SpcAssetChain',
    component: () => import('@/components/investor/SpcAssetChain.vue')
  },
  // V88 - SPC 자본 정합성 진단/복구 도구
  {
    path: '/investor/capital-integrity',
    name: 'SpcCapitalIntegrityReport',
    component: () => import('@/components/investor/SpcCapitalIntegrityReport.vue')
  },
  // Phase 7 (자산체인 통합) — 레거시 메뉴 archive
  // 「모계좌 장부」, 「SPC 자금흐름」 메뉴는 자산체인 화면으로 통합되어 제거.
  // 직접 URL 진입은 자산체인으로 redirect (북마크 호환 보장).
  {
    path: '/investor/dabu-ledger',
    redirect: '/investor/spc-asset-chain'
  },
  {
    path: '/investor/spc-cashflow',
    redirect: '/investor/spc-asset-chain'
  },

  // ==================== 결산 ====================
  // 마감 진행 대시보드 (3단계 통합 현황)
  {
    path: '/closing/dashboard',
    name: 'ClosingDashboard',
    component: () => import('@/components/closing/ClosingDashboard.vue')
  },
  // 일마감
  {
    path: '/closing/loan-repay',
    name: 'DailyClosing',
    component: () => import('@/components/closing/DailyClosing.vue')
  },
  // 교차 일마감 (RMS ↔ CL-LINK)
  {
    path: '/closing/cross',
    name: 'CrossDailyClosing',
    component: () => import('@/components/closing/CrossDailyClosing.vue')
  },
  // SPC 일마감
  {
    path: '/closing/spc',
    name: 'SpcDailyClosing',
    component: () => import('@/components/closing/SpcDailyClosing.vue')
  },
  // 대출평잔 집계 (P4)
  {
    path: '/closing/loan-avg',
    name: 'LoanAvgBalance',
    component: () => import('@/components/closing/LoanAvgBalance.vue')
  },
  // 과거 데이터 재계산 (P5)
  {
    path: '/closing/historical-recalc',
    name: 'HistoricalRecalc',
    component: () => import('@/components/closing/HistoricalRecalc.vue')
  },
  // V120 — 잔액 정합 모니터링 대시보드
  {
    path: '/closing/balance-integrity',
    name: 'BalanceIntegrityDashboard',
    component: () => import('@/components/closing/BalanceIntegrityDashboard.vue')
  },

  // ==================== 연장관리 ====================
  {
    path: '/extension/management',
    name: 'ExtensionManagement',
    component: () => import('@/components/extension/ExtensionManagement.vue')
  },

  // ==================== 환불관리 ====================
  // 환불 현황
  {
    path: '/refund/status',
    name: 'RefundStatus',
    component: () => import('@/components/refund/RefundStatus.vue')
  },

  // ==================== 상환관리 (추가) ====================
  // 계좌 이자
  {
    path: '/repay/account-interest',
    name: 'AccountInterest',
    component: () => import('@/components/repay/AccountInterest.vue')
  },
  // 일별 이자
  {
    path: '/repay/daily-interest',
    name: 'DailyInterest',
    component: () => import('@/components/repay/DailyInterest.vue')
  },
  // 원금상환 처리 (부분/완제 통합)
  {
    path: '/repay/principal',
    name: 'PrincipalRepay',
    component: () => import('@/components/repay/PrincipalRepay.vue')
  },
  // 원금 전액 상환 (완제) — 기존 화면 유지
  {
    path: '/repay/account-principal-full',
    name: 'FullPrincipal',
    component: () => import('@/components/repay/FullPrincipal.vue')
  },
  // 원금 일부 상환 (부분) — 기존 화면 유지
  {
    path: '/repay/account-principal-part',
    name: 'PartialPrincipal',
    component: () => import('@/components/repay/PartialPrincipal.vue')
  },

  // ==================== 상품관리 (추가) ====================
  // 상품 관리
  {
    path: '/product/manage',
    name: 'ProductManager',
    component: () => import('@/components/product/ProductManager.vue')
  },
  // 등급 매칭테이블 관리
  {
    path: '/product/grade-matching',
    name: 'GradeMatchingEditor',
    component: () => import('@/components/product/GradeMatchingEditor.vue')
  },

  // 메뉴 관리
  {
    path: '/admin/menu-manage',
    name: 'AdminMenuManage',
    component: () => import('@/components/login/AdminMenuManage.vue')
  },

  // ==================== 게시판관리 ====================
  // 공지사항 관리
  {
    path: '/board/notice',
    name: 'NoticeManage',
    component: () => import('@/components/board/NoticeManage.vue')
  },
  // FAQ 관리
  {
    path: '/board/faq',
    name: 'FaqManage',
    component: () => import('@/components/board/FaqManage.vue')
  },
  {
    path: '/board/inquiry',
    name: 'InquiryManage',
    component: () => import('@/components/board/InquiryManage.vue')
  },

  // ==================== RMS연계 (추가) ====================
  // 증권계좌등급조회 (TR81001000 + TR81002300)
  {
    path: '/rmslink/acct-grade-query',
    name: 'AccountGradeQuery',
    component: () => import('@/components/rmslink/AccountGradeQuery.vue')
  },
  // 계좌 등급 (기존)
  {
    path: '/rmslink/account-grade',
    name: 'AccountGrade',
    component: () => import('@/components/rmslink/AccountGrade.vue')
  },
  // 등급 대시보드
  {
    path: '/rmslink/grade-dashboard',
    name: 'GradeDashboard',
    component: () => import('@/components/rmslink/GradeDashboard.vue')
  },
  // KRX 업로드
  {
    path: '/rmslink/krx-upload',
    name: 'KrxUpload',
    component: () => import('@/components/rmslink/KrxUpload.vue')
  },
  // RMS 데이터베이스
  {
    path: '/rmslink/database',
    name: 'RmsDatabase',
    component: () => import('@/components/rmslink/RmsDatabase.vue')
  },
  // RMS 서버관리
  {
    path: '/rmslink/rms-server',
    name: 'RmsServerManagement',
    component: () => import('@/components/rmslink/RmsServerManagement.vue')
  }
]

const router = createRouter({
  history: createWebHistory('/app/'),
  routes
})

// ==================== 로그인 체크 네비게이션 가드 ====================
// 모든 페이지 이동 시 로그인 상태를 확인하여 인증되지 않은 경우 로그인 페이지로 리다이렉트
router.beforeEach(async (to, from, next) => {
  // 로그인 페이지: 이미 인증된 상태면 홈으로 리다이렉트 (뒤로가기 방지)
  if (to.name === 'Login') {
    try {
      const contextPath = resolveContextPath()
      await axios.post(`${contextPath}/api/auth/me`, {}, {
        headers: { 'Accept': 'application/json' },
        withCredentials: true
      })
      next({ path: '/', replace: true })
    } catch (e) {
      next()
    }
    return
  }
  
  // 로그인 상태 확인 (서버 API 호출)
  try {
    const contextPath = resolveContextPath()
    await axios.post(`${contextPath}/api/auth/me`, {}, {
      headers: {
        'Accept': 'application/json'
      },
      withCredentials: true // 쿠키 포함
    })
    
    // 로그인 성공 - 페이지 이동 허용
    next()
  } catch (e) {
    // 로그인 실패 또는 네트워크 오류 - 로그인 페이지로 리다이렉트
    console.warn('[Auth Guard] 인증 실패 또는 오류:', e)
    next('/auth/login')
  }
})

function resolveContextPath() {
  const marker = '/app/'
  const path = window.location.pathname
  const idx = path.indexOf(marker)
  return idx > 0 ? path.substring(0, idx) : ''
}

// ==================== 청크 로드 실패 자동 복구 ====================
// 재배포로 청크 해시가 바뀐 상태에서 구버전 index.html 이 새 청크 경로를 찾지 못할 때
// 서버가 SPA fallback 으로 HTML 을 반환 → 브라우저가 JS 로 해석 실패 → MIME 에러 발생
// 이 때 강제 새로고침으로 최신 index.html 을 다시 받아와 복구한다.
router.onError((error, to) => {
  const msg = (error && error.message) ? error.message : ''
  const isChunkLoadError =
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('Loading chunk') ||
    msg.includes('Unable to preload CSS')
  if (!isChunkLoadError) return

  console.warn('[Router] 청크 로드 실패 감지 (신버전 배포 가능성) — 새로고침 시도:', to && to.fullPath, msg)

  // 무한 reload 방지: 10초 이내 재진입 시 추가 reload 차단
  const key = '__chunk_reload_ts'
  const last = Number(sessionStorage.getItem(key) || 0)
  if (Date.now() - last > 10000) {
    sessionStorage.setItem(key, String(Date.now()))
    const target = (to && to.fullPath) ? to.fullPath : window.location.pathname
    window.location.href = target
  } else {
    console.error('[Router] 최근 새로고침 직후 재실패 — 무한 루프 방지로 중단. 수동 새로고침 필요.')
  }
})

export default router
